import type { FC, ReactNode } from "react";

type H2Props = {
  children: ReactNode;
};

const H2: FC<H2Props> = ({ children }) => {
  return (
    <h2 className="text-3xl font-semibold">{children}</h2>
  );
};

export default H2;
